import { Button } from '@noissue-ui-kit/oldBranding/button'
import { TProductDetailSections } from '../useProductPageVariation'

export function useUnavailableProductDetailSection(): TProductDetailSections {
  const priceSection = null
  const btnLabel = 'Unavailable in your Region'
  const mainSection = (
    <Button
      size={'m'}
      corners={'square'}
      className="w-full"
      disabled
      ariaLabel={btnLabel}
    >
      {btnLabel}
    </Button>
  )

  return {
    priceSection,
    mainSection,
  }
}
